module.exports = __webpack_public_path__ + "img/BigGuns.e37febcb.png";